<template>
    <section class="about-top-wrapper">
        <div class="left-shape1"></div>
        <div class="left-shape2"></div>
        <div class="top-left">
            <div class="left-text">
                <span class="top-span1">Kilka słów o nas</span>
                <span class="top-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Sint eius explicabo blanditiis, veniam ratione quasi laboriosam ullam, esse aut optio tenetur consequatur maiores, perspiciatis delectus!</span>
                <span class="top-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Possimus quas dolore eos earum laboriosam quibusdam aspernatur sapiente sed, veniam quod numquam esse fugit voluptate officia unde laborum expedita, omnis molestiae tempora delectus sunt asperiores.</span>
                <span class="top-span1">Stocznia w Norwegii</span>
                <span class="top-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit, veritatis, id vel, blanditiis vitae praesentium at eius rem omnis vero maxime. Velit, at.</span>
                <span class="top-span2">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Molestias eos aperiam ducimus!</span>
            </div>
            <div class="left-img">
                <img src="../../../public/img/norway.png" alt="">
            </div>
        </div>
        <div class="top-right"></div>
    </section>
</template>

<script>
export default {
    name: 'about-top',
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
$shape-color: rgb(242, 242, 242);
.about-top-wrapper {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    .left-shape1 {
        position: absolute;
        width: 150px;
        height: 650px;
        background-color: $shape-color;
        margin: 120px 0 0 30%;
        transform: skew(20deg);
        @include mobileBig {
            width: 80px;
        }
    }

    .left-shape2 {
        margin: 120px 300px 0 50%;
        position: absolute;
        width: 150px;
        height: 650px;
        background-color: $shape-color;
        transform: skew(20deg);
        @include mobileBig {
            width: 80px;
        }
    }
    .top-left {
        padding: 0 200px 0 200px;
        height: auto;
        width: 100%;
        display: flex;
        flex-direction: row;
        text-align: left;
        z-index: 2;
        @include mobileBig {
            padding: 0 50px;
            flex-direction: column;
        }
        .left-text {
            display: flex;
            flex-direction: column;
            width: 60%;
            @include mobileBig {
                width: 100%;
            }
            .top-span1 {
                font-size: 46px;
                margin: 50px 0 0 0;
            }
            .top-span2 {
                font-size: 20px;
                margin: 20px 0 0 0;
                &:last-child {
                    margin: 20px 0 50px 0;
                }
            }
        }
        .left-img {
            width: 40%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            @include mobileBig {
                display: none;
            }
            img {
                max-height: 300px;
                @include mobileBig {
                    max-height: 200px;
                }
            }
        }
    }
    .top-right {
        z-index: 2;
        margin: 0 200px 100px 200px;
        height: 300px;
        width: auto;
        background-size: cover;
        background-position: center;
        background-image: url('../../../public/img/img_home.jpg');
        @include mobileBig {
            margin: 0 50px 50px 50px;
            height: 200px;
        }
    }
}
</style>